module.exports = __webpack_public_path__ + "assets/img/home-wz.330c7f3f.png";